module.exports = __webpack_public_path__ + "img/microchip-grey.51184193.svg";